module.exports = __webpack_public_path__ + "assets/img/bc6a16b4218da38f34638d3ebf8ed46c.svg";